import { License } from "src/models/license";
import { createEntityModel } from "src/store/models/entity/_shared";

export const RpaLicenseEntityModel = createEntityModel<License>(
  (entity) => entity.ownerId
);
